import { InjectionToken } from '@angular/core';

const FEATURES = {
  // KassenSichV cash register / fiscal POS (German Kasse). No PostHog flag
  // exists yet, so this resolves to `false` everywhere → the feature ships
  // dark. Create a `cash-register` flag in PostHog to roll it out, or use the
  // console override (`featureFlags.on('cash-register')`) to test on non-prod.
  'cash-register': false,

  // TEMPORARY (awaiting tax ID): gates every paid Stripe/checkout button —
  // plan subscribe, token purchases, and the billing-portal "manage" button.
  // While OFF, those buttons are hidden (kept in the DOM) and a "Contact us"
  // mailto link is shown in their place. Turn back ON to restore the originals
  // once the tax ID is in place — create/enable a `subscribe-buttons` flag in
  // PostHog for prod, or use the console override on non-prod:
  // `featureFlags.on('subscribe-buttons'); location.reload();`
  'subscribe-buttons': false,
} as const;

export type FeatureFlag = keyof typeof FEATURES;

export const FeatureFlags = new InjectionToken('tvd.feature-flags', {
  providedIn: 'root',
  factory: () => ({
    isFeatureEnabled: (feature: FeatureFlag): boolean => FEATURES[feature],
  }),
});
